export default {
  Administrator: 1,
  User: 2,
  ReadOnly: 3,
};
